export default {
	brand: "#3aaa35",
	primary: "black",
	white: "white",
};
